import FieldValidator from './FieldValidator'
import jQuery from 'jquery'

export default class PhoneNumberFieldValidator extends FieldValidator {

  validateValue(value, input) {
    return jQuery(input).intlTelInput('isValidNumber')
  }

}